import styled from "styled-components";

interface InquiryPrivatItemStyleProps {
  $status: string;
}

export const InquiryPrivateItem = styled.li`
  display: flex;
  padding: 20px;
  background: ${(props) => props.theme.colors.white100};
  border-radius: 10px;
  flex-direction: column;
  gap: 20px;
`;

export const InquiryPrivateTit = styled.div<InquiryPrivatItemStyleProps>`
  display: flex;
  padding-bottom: 20px;
  font-size: 1.5rem;
  font-weight: 500;
  border-bottom: 1px solid ${(props) => props.theme.colors.black5};
  flex-direction: column;
  gap: 10px;

  span {
    width: fit-content;
    padding: 4px 6px;
    color: ${(props) =>
      props.$status === "wait"
        ? props.theme.colors.black60
        : props.theme.colors.primary100};
    font-size: 1rem;
    font-weight: 600;
    background: ${(props) =>
      props.$status === "wait"
        ? props.theme.colors.black12
        : props.theme.colors.primary12};
    border-radius: 4px;
  }
`;

export const InquiryPrivateContent = styled.div`
  font-size: 1.3rem;
  font-weight: 300;
  line-height: 140%;
  white-space: pre-line;
`;

export const AnswerContent = styled.div`
  display: flex;
  padding: 16px;
  font-size: 1.3rem;
  font-weight: 400;
  line-height: 140%;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.mainBg};
  gap: 8px;
  white-space: pre-line;

  span {
    color: ${(props) => props.theme.colors.primary100};
    font-size: 1.2rem;
    font-weight: 600;
  }
`;
